<template>
	<transition name="modal-fade">
		<div class="modal-backdrop">
			<div class="modal">

					<div class="bg-linear-4 w-full bg-cover overflow-auto h-screen">
						<div class="px-5 pt-20 pb-28">
							<div class="absolute top-3 right-4 flex gap-1 items-center" @click="close">
								<span class="text-base text-white">{{ $t('homepage_modal_close') }}</span>
								<a href="#"><img src="../assets/images/button-close.svg" alt=""></a>
							</div>
							<div class="text-center relative" style="margin-bottom: 32px;">
								<h2 class="text-3xl font-black text-white">{{ $t('homepage_modal_title_1') }}</h2>
								<h2 class="text-3xl font-black text-white">{{ $t('homepage_modal_title_2') }}</h2>
							</div>
							<div class="text-center">
								<img class="mx-auto" src="../assets/images/airpod-max.png" alt="" style="width: 90%;">
								<h2 class="text-2xl font-bold text-white">{{ $t('homepage_modal_giveaway') }} AirPods Max</h2>
								<p class="text-sm text-white font-medium">{{ $t('homepage_modal_desc_win_1') }}</p>
							</div>
							<div class="text-center relative mt-6">
							<h2 class="text-2xl font-bold text-white">{{ $t('homepage_modal_weekly') }}</h2>
							<!-- <div class="mt-4 text-center">
								<img class="w-52 mx-auto" src="../assets/images/lazada-voucher.png" alt="">
								<h3 class="text-lg text-white font-bold mt-1">บัตรกำนัล Lazada</h3>
								<p class="text-sm text-white font-medium">รางวัลสำหรับผู้ที่ได้คะแนนสะสมสูงสุดประจำสัปดาห์ 20 รางวัล ประกาศผลรายชื่อผู้ได้รับรางวัลทุกสัปดาห์</p>
							</div> -->
							<div class="mt-5 text-center">
								<div class="relative w-52 mx-auto">
									<img class="object-contain mx-auto" src="../assets/images/grab-voucher.png" alt="">
									<div class="absolute bottom-4 -left-1">
										<img src="../assets/images/total-lazada-voucher.png" class="w-14 h-12" alt="">
									</div>
								</div>
								<h3 class="text-lg text-white font-bold mt-1">Grab {{ $t('leaderboard_modal_voucher') }}</h3>
								<p class="text-sm text-white font-medium">{{ $t('homepage_modal_desc_win_2') }}</p>
							</div>
							<div class="mt-5 text-center">
								<div class="relative w-52 h-32 mx-auto mb-10">
									<img class="object-contain mx-auto" src="../assets/images/grab-voucher.png" alt="">
									<div class="absolute -bottom-7 -left-4">
										<img src="../assets/images/1000-item.png">
									</div>
								</div>
								<h3 class="text-lg text-white font-bold">{{ $t('homepage_modal_giveaway') }} Grab Vouchers</h3>
								<p class="text-sm text-white font-medium">{{ $t('homepage_modal_desc_win_3') }}</p>
								<p class="text-sm text-white font-medium">{{ $t('homepage_modal_desc_win_4') }}</p>
							</div>
							<div class="mt-14 w-76 mx-auto border-2 border-yellow-1 rounded-xl p-4">
								<h3 class="text-2xl font-bold text-yellow-1 text-center">{{ $t('homepage_modal_how') }}</h3>
								<div class="flex items-center gap-4 mt-5">
										<img class="w-12 h-12" src="../assets/images/flick-hand.svg" alt="">
										<p class="text-sm text-yellow-1 text-left">{{ $t('homepage_modal_step_1') }}</p>
									</div>
									<div class="flex items-center gap-4 mt-5">
										<img class="w-12 h-12" src="../assets/images/leaf-life.svg" alt="">
										<p class="text-sm text-yellow-1 text-left">{{ $t('homepage_modal_step_2') }}</p>
									</div>
									<div class="flex items-center gap-4 mt-5">
										<img class="w-12 h-12" src="../assets/images/friend.svg" alt="">
										<p class="text-sm text-yellow-1 text-left">{{ $t('homepage_modal_step_3') }}</p>
									</div>
									<div class="flex items-center gap-4 mt-5">
										<img class="w-12 h-12" src="../assets/images/share.svg" alt="">
										<p class="text-sm text-yellow-1 text-left">{{ $t('homepage_modal_step_4') }}</p>
									</div>
									<div class="flex items-center gap-4 mt-5">
										<img class="w-12 h-12" src="../assets/images/camera-yellow.svg" alt="">
										<p class="text-sm text-yellow-1 text-left">{{ $t('homepage_modal_step_5') }}</p>
									</div>
							</div>
							
							<router-link to="terms-and-condition">
								<span class="mt-3.5 text-sm font-bold text-yellow-1 text-center block underline" @click="close">*{{ $t('homepage_modal_terms') }}</span>
							</router-link>
						</div>
					</div>
				</div>
			</div>

		<audio-component></audio-component>

		</div>
	</transition>
</template>

<script>
import AudioComponent from '@/components/AudioComponent.vue'
import { Howl, Howler } from 'howler';
  export default {
    name: 'ModalPages',
	components: {
		AudioComponent,
	},
	mounted() {
		this.$store.commit('SET_GAME_BACKSOUND', false)
	},
    methods: {
      close () {
		  this.$parent.$parent.sfx.leave.play()
          this.$emit('close')
      },
    }
  }
</script>